import {Routes} from '@angular/router'
import {adminAuthGuard, LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'
import {LOGIN_ROUTE_PATH, SCAN_ROUTE_PATH} from './0-application/app'
import {StartComponent} from './1-start/start.component'

export const routes: Routes = [
  {
    path: SCAN_ROUTE_PATH,
    canActivate: [adminAuthGuard],
    component: StartComponent
  },
  {
    path: LOGIN_ROUTE_PATH,
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: LOGIN_ROUTE_PATH
  }
]
